import { render, staticRenderFns } from "./CurrencyInput.vue?vue&type=template&id=2d75ea7a&scoped=true&"
import script from "./CurrencyInput.vue?vue&type=script&lang=ts&"
export * from "./CurrencyInput.vue?vue&type=script&lang=ts&"
import style0 from "./CurrencyInput.vue?vue&type=style&index=0&id=2d75ea7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d75ea7a",
  null
  
)

export default component.exports